import React, { useState, useEffect, Fragment } from 'react';
import { useStore } from '@nanostores/react';
import { isCartOpen, cartData } from '@stores/cartStore.js';
// import { swatchList } from '@stores/swatchStore.js'
import Modal from 'react-modal';
import useWindowDimensions from '@hooks/useWindowDimensions.js';
import { userData } from '@stores/userStore';
import { getRegistry } from '../../api/shopify';
import va from '@vercel/analytics';
import { chord } from '@api/chord.js';
import { updateCartAttributes } from '@api/shopify.js';

import Ribbon from '@components/SaleRibbon/Ribbon.jsx';
import Price from '@components/Price/Price.jsx';
import Buy3Get30 from '@components/SaleRibbon/Buy3Get30.jsx';
import Buy3Get35 from '@components/SaleRibbon/Buy3Get35.jsx';
import Buy2Get25 from '@components/SaleRibbon/Buy2Get25.jsx';
import Tag30Off from '@components/SaleRibbon/Tag30Off.jsx';
import SizeGuide from '@components/SizeGuide/SizeGuide.jsx';
import Heart from '@components/Icons/Heart.jsx';

import {
	slugify,
	fileNameAndExt,
	SIZES,
	getUniqueListBy,
	sizeSortFunc,
	insertUrlParam,
	convertToCurrency,
	round,
	getCookie,
} from '@utils/utils.js';

import { createCart, addToCart } from '@api/shopify.js';
import { hasCartQuantityError } from '../../stores/cartStore';

Modal.setAppElement('*'); // suppresses modal-related test warnings.

const FILES_URL = 'https://cdn.shopify.com/s/files/1/2338/2917/files/';

const DEFAULT_IMAGE_SRC =
	'https://cdn.shopify.com/s/files/1/2338/2917/files/default-image.png?v=1628278950';

const DEFAULT_SWATCH_IMAGE_SRC =
	'https://cdn.shopify.com/s/files/1/2338/2917/files/maswatch-default-96.png';

const tagsArray = ['Buy2Get25', 'Buy3Get30', 'Buy3Get35'];

const registryHtml = `<span class="flex items-center justify-center gap-2"><div class='heart-icon w-[24px] max-w-[24px]'><svg xmlns="http://www.w3.org/2000/svg" x="0" y="0" enableBackground="new 0 0 100 100" version="1.1" viewBox="0 0 100 100" xmlSpace="preserve"><path d="M49.9 91.9L8.1 50.1c-9-9-9-23.6 0-32.6s23.6-9 32.6 0l9.2 9.2 9.2-9.2c9-9 23.6-9 32.6 0s9 23.6 0 32.6L49.9 91.9zM12.6 22c-6.5 6.5-6.5 17.1 0 23.6l37.3 37.3 37.3-37.3c6.5-6.5 6.5-17.1 0-23.6s-17.1-6.5-23.6 0L49.9 35.7 36.2 22c-6.5-6.5-17.1-6.5-23.6 0z" className="st0" fill="#414042"></path></svg></div>Add To Babylist Registry</span>`;

const productTypes40Off = ['Swimwear', 'Sun Hats', 'Swim Coverups'];

const QuickBuy = ({
	product,
	products,
	quickBuyActive,
	setQuickBuyActive,
	variant,
	variants,
	variantId,
	image,
	color,
	embroidery,
	isPLPTest,
	plpTestId,
	type,
	extraProducts,
}) => {
	// const $swatchList = useState(swatchList)

	// const swatches = swatchList.get()

	const [cart, setCart] = useState();
	const $cartData = useStore(cartData);
	const $user = useStore(userData);
	const [modalIsOpen, setIsOpen] = useState(false);
	const [key, setKey] = React.useState(0);
	const { windowWidth, windowHeight } = useWindowDimensions();

	const [currentProductUrl, setCurrentProductUrl] = useState();

	let currentBaseUrl;
	let productUrl;
	let productHandle;
	let isGet30Off = false;

	if (product && product.handle) {
		productHandle = product.handle.split('_')[0];
		productHandle = productHandle.replace(/trunk-sale-/g, '');
		// productHandle = productHandle.replace(/sale-/g, '')
		productHandle = productHandle.replace(/-1$/, '');
		productHandle = productHandle.replace(/-2$/, '');
		productHandle = productHandle.replace(/-3$/, '');
		productHandle = productHandle.replace(/-4$/, '');
		productHandle = productHandle.replace(/-5$/, '');
	}

	let productTitle;

	if (product?.title) {
		productTitle = product.title;
	} else if (product?.name) {
		productTitle = product.name;
	}

	if (productTitle.split('_')[1] !== color) {
		const productFound = extraProducts?.filter((p) => {
			return p.title.split('_')[1] === color;
		})[0];
		if (productFound !== undefined) {
			product = productFound;
		}
	}

	// product tags
	let tags;
	let intersection;
	let vendor;
	let productType;
	let is20Off = false;
	let is25Off = false;
	let is30Off = false;
	let is40Off = false;
	let discountedPrice = null;

	if (product) {
		tags = product.tags || product.tags1;
		vendor = product.vendor || product.brand;
		productType = product.product_type;
	}

	if (tags) {
		intersection = tagsArray.filter((element) => tags.includes(element))[0];

		if (tags.includes('fallsavingsevent2023')) {
			isGet30Off = true;
		}
	}

	// variants
	let allProductVariants = variants.filter((v) => {
		if (v.product_title && product && product.title) {
			return (
				v.product_title.split('_')[0] === product.title.split('_')[0]
			);
		} else if (v.product_title && product && product.name) {
			return v.product_title.split('_')[0] === product.name.split('_')[0];
		}
		return null;
	});

	if (allProductVariants.length > 0) {
		variants = allProductVariants;
	}

	const v = variant;

	let imageSrc;
	let smallImageSource;
	let imageSrcArray;

	if (image && image.src) {
		//
		imageSrc = image.src;
	} else if (variant && variant.image) {
		// product has variant(s) — use variant image
		imageSrc = variant.image;
	} else if (product) {
		// product has no variants; use product image instead
		if (product.images_info && product.images_info.length > 0) {
			imageSrc = product.images_info[0]
				? product.images_info[0].src
				: null;
		} else {
			imageSrc = image;
		}
	}

	let imageAlt;

	if (product?.images_info && product?.images_info.length > 0) {
		imageAlt = product?.images_info[0]?.alt;
	} else if (product?.title) {
		imageAlt = product?.title;
	} else if (product?.name) {
		imageAlt = product?.name;
	} else {
		imageAlt = 'variant image';
	}

	if (imageSrc) {
		//
		imageSrcArray = fileNameAndExt(imageSrc);
		//

		if (windowWidth && windowWidth < 768) {
			smallImageSource = imageSrc;
		} else {
			smallImageSource =
				imageSrcArray[0] +
				'/' +
				imageSrcArray[1]
					.replace(/_600x900(?!.*_600x900)/, '')
					.replace(/_1200x1800(?!.*_1200x1800)/, '') +
				'_1200x1800.' +
				imageSrcArray[2];
		}
	} else {
		imageSrc = DEFAULT_IMAGE_SRC;
	}

	let initialColor;
	if (variant && variant.initial_color) {
		initialColor = variant.initial_color.replace(/\//g, ' ');
	}

	const [sizes, setSizes] = useState('');
	const [currentPattern, setCurrentPattern] = useState(
		color
			? color
			: variant && variant.initial_color
			? variant.initial_color
			: ''
	);
	const [currentImage, setCurrentImage] = useState({
		src: smallImageSource ? smallImageSource : imageSrc,
		alt: imageAlt,
	});
	const [value, setValue] = useState('Size');

	const [currentProduct, setCurrentProduct] = useState(product);
	const [currentVariantId, setCurrentVariantId] = useState(
		variantId
			? variantId
			: variant && variant.id
			? variant.id
			: variants && variants[0]
			? variants[0].id
			: ''
	);
	const [currentVariantPrice, setCurrentVariantPrice] = useState({
		price: variant && variant.price ? variant.price : '',
		compareAtPrice:
			variant && variant.compare_at_price ? variant.compare_at_price : '',
		discountPrice: discountedPrice,
	});

	// const [currentVariantPrice.discountPrice, setcurrentVariantPrice.discountPrice] =
	// 	useState(discountedPrice)

	const [variantQuantity, setVariantQuantity] = useState(1);
	const [ribbon, setRibbon] = useState(false);
	const [isBundle, setIsBundle] = useState(intersection);

	const bundleRibbons = {
		Buy2Get25: <Buy2Get25 />,
		Buy3Get30: <Buy3Get30 />,
		Buy3Get35: <Buy3Get35 />,
	};

	let patternList = variants
		.filter((p) => {
			return (
				p?.title?.split('_')[0].toLowerCase() ===
				v?.title?.split('_')[0].toLowerCase()
			);
		})
		.map((v) => {
			if (v?.locations?.includes('instock:logicbroker') > -1) {
				return v?.initial_color;
			} else if (v?.inventory_quantity > 0) {
				return v?.initial_color;
			}
			return null;
		});

	// remove any null values from patternList
	patternList = patternList.filter((e) => e != null);

	let extraSwatchesProducts = extraProducts?.filter((swatch) => {
		return !patternList.includes(swatch.title.split('_')[1]);
	});

	extraSwatchesProducts?.forEach((p) => {
		if (
			p.title.split('_')[0].toLowerCase() ===
			product.title.split('_')[0].toLowerCase()
		) {
			patternList.push(p.variants[0].initial_color);
		}
	});

	const patterns = [...new Set(patternList)];

	let matchingVariants = variants.filter((m) => {
		if (m?.locations?.includes('instock:logicbroker') > -1) {
			return m.product_id === v.product_id;
		} else {
			return (
				m.product_id === v.product_id &&
				m.initial_color === v.initial_color
			);
		}
	});

	const [currentSize, setCurrentSize] = useState({
		size: '',
		variantId: '',
		sku: '',
	});

	const [quantity, setQuantity] = useState(1);

	useEffect(() => {
		let initialSizes = [];

		variants.map((v) => {
			if (v.initial_size && v.initial_color === currentPattern) {
				initialSizes.push({
					variantId: v.id,
					inventory_quantity: v.inventory_quantity,
					sku: v.sku,
					productId: v.product_id,
					price: v.price,
					initial_size: v.initial_size,
				});
			}
			return null;
		});

		if (initialSizes?.length <= 0 && extraProducts?.length > 0) {
			extraProducts.map((prod) => {
				if (
					prod.initial_size &&
					prod.variants[0].initial_color === currentPattern
				) {
					prod.variants.map((v) => {
						initialSizes.push({
							variantId: v.id,
							inventory_quantity: v.inventory_quantity,
							sku: v.sku,
							productId: v.product_id,
							price: v.price,
							initial_size: v.initial_size,
						});
					});
				}
			});
		}

		if (initialSizes.length > 0) {
			let sortedSizeList = initialSizes.sort(sizeSortFunc);

			sortedSizeList = getUniqueListBy(sortedSizeList, 'initial_size');

			sortedSizeList = sortedSizeList.filter(function (e) {
				return e !== null && e !== undefined && e !== '';
			});
			if (sortedSizeList) {
				setSizes(sortedSizeList);
			}
		} else {
			setCurrentSize({
				size: 'nosize',
				variantId: variant && variant && variant.id,
				sku: variant && variant && variant.sku,
			});
			setSizes([]);
		}
	}, []);

	useEffect(() => {
		currentBaseUrl = location.origin;

		//

		productUrl = `${currentBaseUrl}/products/${productHandle}${
			currentVariantId ? '?variant=' + currentVariantId : ''
		}`;

		//
		setCurrentProductUrl(productUrl);
	}, [currentVariantId]);

	let firstVariant = variants.find(function (el) {
		if (el.locations && el.locations.includes('instock:logicbroker') > -1) {
			return el;
		} else if (el.product_type === 'Virtual Classes') {
			return el;
		} else {
			return el.inventory_quantity > 0;
		}
	});

	const handleSwatchClick = (pattern) => {
		setCurrentPattern(pattern);

		let btnEl = document.querySelectorAll(`.registry-trigger`);
		btnEl.forEach((i) => (i.innerHTML = registryHtml));

		const swatchSlug = slugify(pattern);

		setQuantity(1);

		let matchingVariants = variants.filter((v) => {
			return v.initial_color === pattern;
		});

		if (matchingVariants.length <= 0) {
			let matchProduct = extraSwatchesProducts.filter((p) => {
				return p.title.split('_')[1] === pattern;
			});
			matchingVariants = matchProduct[0].variants.map((v) => {
				let gender;
				const options = v?.merged_options;
				const genderOption = options?.find((o) =>
					o.includes('gender:')
				);
				if (genderOption) {
					gender = genderOption.split(':')[1];
				}
				return {
					...v,
					created_at: matchProduct.created_at,
					product_title: matchProduct.title,
					id_pattern:
						v.initial_color && v.initial_color.length
							? matchProduct.product_id +
							  '_' +
							  slugify(v.initial_color)
							: matchProduct.product_id + '_one-color',
					gender: gender ? gender : 'Unisex',
				};
			});
		}
		let sizeList = [];

		// extract sizes from new matches
		matchingVariants.map((v) => {
			if (v.initial_size && v.initial_size !== '') {
				sizeList.push({
					variantId: v.id,
					inventory_quantity: v.inventory_quantity,
					sku: v.sku,
					productId: v.product_id,
					price: v.price,
					initial_size: v.initial_size,
				});
			}

			return null;
		});

		let sortedSizeList = sizeList.sort(sizeSortFunc);

		sortedSizeList = getUniqueListBy(sortedSizeList, 'initial_size');

		//

		if (sortedSizeList) {
			setSizes(sortedSizeList);
		}

		// const firstMatchWithInventory = matchingVariants.find(function (el) {
		//     return el.inventory_quantity > 0
		// })

		// First try to find any variant matching current size with inventory > 0
		let firstMatchWithInventory = matchingVariants.find(function (el) {
			return (
				currentSize.size &&
				el.initial_size === currentSize.size &&
				el.inventory_quantity > 0
			);
		});

		// If no size match found with inventory, fall back to first variant with inventory > 0
		if (!firstMatchWithInventory) {
			firstMatchWithInventory = matchingVariants.find(function (el) {
				return el.inventory_quantity > 0;
			});
		}

		let matchingProduct = products.filter((p) => {
			return p.id === firstMatchWithInventory.product_id;
		});
		if (matchingProduct.length <= 0) {
			matchingProduct = extraProducts.filter((p) => {
				return p.id === firstMatchWithInventory.product_id;
			});
		}
		setCurrentProduct(matchingProduct[0]);

		if (firstMatchWithInventory) {
			setCurrentImage({
				src: firstMatchWithInventory.image,
				alt: imageAlt,
			});
		}

		if (
			currentSize.size &&
			currentSize.size !== '' &&
			currentSize.size !== null &&
			currentSize.size !== 'nosize'
		) {
			if (firstMatchWithInventory && firstMatchWithInventory.id) {
				setCurrentVariantId(firstMatchWithInventory.id);
				setVariantQuantity(firstMatchWithInventory.inventory_quantity);

				setCurrentSize({
					size: firstMatchWithInventory.initial_size,
					variantId: firstMatchWithInventory.id,
					sku: firstMatchWithInventory.sku,
				});
			} else {
				setCurrentVariantId(matchingVariants[0].id);
				setVariantQuantity(matchingVariants[0].inventory_quantity);
			}
		} else {
			// get variant ID for new pattern variant in selected size
			let selectedSizeVariant = matchingVariants.filter((m) => {
				return m.initial_size === currentSize.size;
			});

			setCurrentVariantId(
				selectedSizeVariant[0]?.id ?? matchingVariants[0].id
			);
			setVariantQuantity(
				selectedSizeVariant[0]?.inventory_quantity ??
					matchingVariants[0].inventory_quantity
			);

			setCurrentSize({
				size: currentSize.size,
				variantId: selectedSizeVariant[0]?.id ?? matchingVariants[0].id,
				sku: selectedSizeVariant[0]?.sku ?? matchingVariants[0].sku,
			});

			if (
				intersection &&
				intersection !== '' &&
				product.title.indexOf('SALE') === -1
			) {
				setIsBundle(intersection);
			} else {
				setIsBundle(false);
			}
		}

		const variantId = matchingVariants[0]?.id;

		const productHasSelectedVariant = !!product?.variants?.find((v) => {
			return v?.id === variantId;
		});

		const productForSelectedVariant = productHasSelectedVariant
			? product
			: products?.find((p) =>
					p.variants?.find((v) => v?.id === variantId)
			  );

		chord.trackProductClicked({
			cart: $cartData,
			product: {
				product: productForSelectedVariant,
				variantId,
			},
		});
	};

	const handleSizeSelect = (e) => {
		let variantId =
			e.target[e.target.selectedIndex].getAttribute('data-variant-id');
		setVariantQuantity(
			e.target[e.target.selectedIndex].getAttribute('data-inventory')
		);

		setValue(e.target.value);
		setCurrentVariantId(variantId);
		setCurrentSize({
			size: e.target.value,
			variantId: variantId,
			sku: e.target[e.target.selectedIndex].getAttribute('data-sku'),
		});
	};

	const nullFunction = () => {};

	const handleSizeClick = (size, variantId, index, sku) => {
		let btnEl = document.querySelectorAll(`.registry-trigger`);
		btnEl.forEach((i) => (i.innerHTML = registryHtml));

		// insertUrlParam('variant', variantId)
		// let el = document.querySelectorAll('.registry-actions')
		// el[0].firstChild.innerText = 'Add To Babylist Registry'
		let ele = document.getElementsByClassName('size size-selected');
		if (ele.length > 0) {
			ele[0].classList.remove('size-selected');
		}
		//
		setCurrentSize({
			size: size,
			variantId: variantId,
			sku: sku,
		});
		setCurrentVariantId(variantId);
		setQuantity(1);

		// const objDiv = document.getElementById("quick-buy");

		const addToCartButton = document.getElementById(
			'quick-buy-add-to-cart'
		);

		addToCartButton.scrollIntoView({
			behavior: 'smooth',
		});

		//
		// // objDiv.scrollTop = objDiv.scrollHeight;
		// objDiv.scrollTo({
		//     bottom: 100,
		//     left: 100,
		//     behavior: 'smooth'
		//   });
	};

	const handleQuantityDecrement = () => {
		if (quantity > 1) {
			setQuantity(quantity - 1);
		}
	};

	const handleQuantityChange = (e) => {
		if (e.target.value > 0) {
			setQuantity(e.target.value);
		}
	};

	const handleQuantityIncrement = () => {
		setQuantity(quantity + 1);
	};

	const handleAddToCart = async (e) => {
		//

		const noClick = e.target.classList.contains('noclick');

		if (noClick) {
			return;
		}
		e.preventDefault();

		const cje = getCookie('cje') || 'cje_cookie';

		let cartId = $cartData.cartId || '';

		let variantId = currentVariantId || '';
		let productForSelectedVariant = products?.find((p) =>
			p.variants?.find((v) => v?.id === variantId)
		);
		if (productForSelectedVariant === undefined) {
			productForSelectedVariant = extraProducts?.find((p) =>
				p.variants?.find((v) => v?.id === variantId)
			);
		}

		let lines;
		if (productForSelectedVariant.tags.includes('bundle-builder-product')) {
			// find out the corresponding metafield for the variant in the product
			const metafieldForSelectedVariant =
				productForSelectedVariant.metafields.find(
					(m) => m.id === variantId
				);
			const originalProducts = JSON.parse(
				metafieldForSelectedVariant.value
			);
			lines = originalProducts.map((p) => {
				return {
					quantity: 1,
					merchandiseId: `gid://shopify/ProductVariant/${p.variant_id}`,
					attributes: [
						{
							key: '_bundle_info',
							value: JSON.stringify({
								bundle_id: productForSelectedVariant.id,
								bundle_name: productForSelectedVariant.title,
								bundle_size:
									currentSize.size === ''
										? 'nosize'
										: currentSize.size,
								bundle_total_products: originalProducts.length,
							}),
						},
						{
							key: '_pid',
							value: `${p.product_id}`,
						},
					],
				};
			});
		} else {
			lines = {
				quantity: 1,
				merchandiseId: `gid://shopify/ProductVariant/${variantId}`,
				attributes: [
					{
						// Stuff the PID here to be able to call the cart findmine widget.
						key: '_pid',
						value: `${productForSelectedVariant.id}`,
					},
				],
			};
		}

		if (!cartId || cartId === '') {
			let cartCreateData = await createCart();
			cartId = cartCreateData.data.cartId;

			let cartObj = {
				...cartData.get(),
				cartId: cartId,
				checkoutUrl: cartCreateData.data.checkoutUrl,
			};

			cartData.set(cartObj);

			addToCart(cartId, lines).then((addToCartData) => {
				if (!addToCartData?.body?.cartLinesAdd?.cart) {
					hasCartQuantityError.set(true);
					isCartOpen.set('is_cart_open', true);
					return;
				}
				let cartLines =
					addToCartData.body.cartLinesAdd.cart.lines.edges;
				let cartCost = addToCartData.body.cartLinesAdd.cart.cost;

				let cartObj = {
					...cartData.get(),
					lines: cartLines,
					cost: cartCost,
				};

				cartData.set(cartObj);

				isCartOpen.set('is_cart_open', true);

				const productHasSelectedVariant = !!product?.variants?.find(
					(v) => {
						return v?.id === variantId;
					}
				);

				const productForSelectedVariant = productHasSelectedVariant
					? product
					: products?.find((p) =>
							p.variants?.find((v) => v?.id === variantId)
					  );

				chord.trackProductAdded({
					cart: $cartData,
					product: {
						product: productForSelectedVariant,
						quantity,
						variantId,
					},
				});

				dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
				dataLayer.push({
					event: 'add_to_cart',
					page: 'plp',
					type: type ? type : 'quickbuy',
					ecommerce: {
						currency: 'USD',
						value: Number(currentVariantPrice.price),
						items: [
							{
								item_id: String(variantId),
								item_name: product.title,
								affiliation: 'Vercel',
								item_brand: 'Monica + Andy',
								item_category: currentPattern
									? currentPattern
									: '',
								item_category2: currentSize?.size,
								item_variant: String(currentSize?.variantId),
								price: Number(currentVariantPrice.price),
								quantity: quantity,
							},
						],
					},
				});

				dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
				dataLayer.push({
					event: 'GA4_add_to_cart',
					page: 'plp',
					type: type ? type : 'quickbuy',
					ecommerce: {
						currency: 'USD',
						value: Number(currentVariantPrice.price),
						items: [
							{
								item_id: String(variantId),
								item_name: product.title,
								affiliation: 'Vercel',
								item_brand: 'Monica + Andy',
								item_category: currentPattern
									? currentPattern
									: '',
								item_category2: currentSize?.size,
								item_variant: String(currentSize?.variantId),
								price: Number(currentVariantPrice.price),
								quantity: quantity,
							},
						],
					},
				});

				va.track('QuickBuy Add To Cart', {
					productName: product.title,
					productSku: currentSize?.sku,
					productBrand: product?.vendor
						? product.vendor
						: 'Monica + Andy',
					productColor: currentPattern ? currentPattern : '',
					productSize: currentSize?.size,
					productVariant: currentSize?.variantId,
					productPrice: currentVariantPrice.price,
					productQuantity: quantity,
					type: type ? type : 'quickbuy',
				});

				var atcItem = {
					name: product.title, // Replace with dynamic product name
					price: currentVariantPrice.price, // Replace with dynamic product price
					productID: currentProduct?.id
						? currentProduct?.id
						: currentSize?.variantId, // Replace with dynamic product ID
					variantID: currentSize?.variantId,
					categories: currentPattern ? currentPattern : '', // Replace with dynamic product categories (optional)
					imageURL: currentImage ? currentImage.src : '', // Replace with dynamic product image URL
					URL: window?.location?.href, // Replace with dynamic product page URL
					brand: variant ? variant.vendor : '', // Replace with dynamic product brand (optional)
				};
				closeModal();

				const nostoCartLines = cartLines.map((line) => {
					const productId = line.node.merchandise.product.id;
					const productIdNumber = productId.split('/').pop();
					const skuId = line.node.merchandise.id;
					const skuIdNumber = skuId.split('/').pop();
					return {
						name: line.node.merchandise.product.title,
						price_currency_code: 'USD',
						product_id: productIdNumber,
						quantity: line.node.quantity,
						sku_id: skuIdNumber,
						unit_price: Number(line.node.cost.totalAmount.amount),
					};
				});

				nostojs((api) => {
					api.defaultSession()
						.setCart({
							items: nostoCartLines,
						})
						.viewCart()
						.update()
						.then((response) => {
							// Handle the response here
							return response;
						})
						.catch((error) => {
							console.error('Nosto cart update error:', error);
						});
				});

				if (cje) {
					let attributes = $cartData.attributes;
					if (!attributes) {
						attributes = [];
					}
					attributes.push({ key: 'cjevent', value: cje });
					updateCartAttributes(cartId, attributes);
				}

				if (TriplePixel) {
					TriplePixel('AddToCart', {
						item: currentProduct?.id
							? currentProduct?.id
							: currentSize?.variantId,
						q: quantity,
						v: currentSize?.variantId,
						atcItem: atcItem,
						productID: currentProduct?.id
							? currentProduct?.id
							: currentSize?.variantId,
					});
				}

				var _learnq = _learnq || [];
				_learnq.push(['track', 'Added to Cart', atcItem]);

				let klaviyo = window.klaviyo || [];
				klaviyo.push(['track', 'Added to Cart', atcItem]);
			});
		} else {
			addToCart(cartId, lines).then((addToCartData) => {
				if (!addToCartData?.body?.cartLinesAdd?.cart) {
					hasCartQuantityError.set(true);
					isCartOpen.set('is_cart_open', true);
					return;
				}

				let cartLines =
					addToCartData.body.cartLinesAdd.cart.lines.edges;
				let cartCost = addToCartData.body.cartLinesAdd.cart.cost;

				let cartObj = {
					...cartData.get(),
					lines: cartLines,
					cost: cartCost,
				};

				cartData.set(cartObj);

				isCartOpen.set('is_cart_open', true);

				const productHasSelectedVariant = !!product?.variants?.find(
					(v) => {
						return v?.id === variantId;
					}
				);

				const productForSelectedVariant = productHasSelectedVariant
					? product
					: products?.find((p) =>
							p.variants?.find((v) => v?.id === variantId)
					  );

				chord.trackProductAdded({
					cart: $cartData,
					product: {
						product: productForSelectedVariant,
						quantity,
						variantId,
					},
				});

				dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
				dataLayer.push({
					event: 'add_to_cart',
					page: 'plp',
					ecommerce: {
						currency: 'USD',
						value: Number(currentVariantPrice.price),
						items: [
							{
								item_id: String(variantId),
								item_name: product.title,
								affiliation: 'Vercel',
								item_brand: 'Monica + Andy',
								item_category: currentPattern
									? currentPattern
									: '',
								item_category2: currentSize?.size,
								item_variant: String(currentSize?.variantId),
								price: Number(currentVariantPrice.price),
								quantity: quantity,
							},
						],
					},
				});

				dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
				dataLayer.push({
					event: 'GA4_add_to_cart',
					page: 'plp',
					ecommerce: {
						currency: 'USD',
						value: Number(currentVariantPrice.price),
						items: [
							{
								item_id: String(variantId),
								item_name: product.title,
								affiliation: 'Vercel',
								item_brand: 'Monica + Andy',
								item_category: currentPattern
									? currentPattern
									: '',
								item_category2: currentSize?.size,
								item_variant: String(currentSize?.variantId),
								price: Number(currentVariantPrice.price),
								quantity: quantity,
							},
						],
					},
				});

				va.track('QuickBuy Add To Cart');

				var atcItem = {
					name: product.title, // Replace with dynamic product name
					price: currentVariantPrice.price, // Replace with dynamic product price
					productID: currentSize?.variantId, // Replace with dynamic product ID
					categories: currentPattern ? currentPattern : '', // Replace with dynamic product categories (optional)
					imageURL: currentImage ? currentImage.src : '', // Replace with dynamic product image URL
					URL: window?.location?.href, // Replace with dynamic product page URL
					brand: variant ? variant.vendor : '', // Replace with dynamic product brand (optional)
				};
				closeModal();

				const nostoCartLines = cartLines.map((line) => {
					return {
						name: line.node.merchandise.product.title,
						price_currency_code: 'USD',
						product_id: line.node.merchandise.product.id,
						quantity: line.node.quantity,
						sku_id: line.node.merchandise.id,
						unit_price: line.node.cost.totalAmount.amount,
					};
				});

				nostojs((api) => {
					api.defaultSession()
						.setCart({
							items: nostoCartLines,
						})
						.viewCart()
						.update()
						.then((response) => {
							// Handle the response here
							return response;
						})
						.catch((error) => {
							console.error('Nosto cart update error:', error);
						});
				});

				if (cje) {
					let attributes = $cartData.attributes;
					if (!attributes) {
						attributes = [];
					}
					attributes.push({ key: 'cjevent', value: cje });
					updateCartAttributes(cartId, attributes);
				}

				if (TriplePixel) {
					TriplePixel('AddToCart', {
						item: currentProduct?.id
							? currentProduct?.id
							: currentSize?.variantId,
						q: quantity,
						v: currentSize?.variantId,
						atcItem: atcItem,
						productID: currentProduct?.id
							? currentProduct?.id
							: currentSize?.variantId,
					});
				}

				var _learnq = _learnq || [];
				_learnq.push(['track', 'Added to Cart', atcItem]);

				let klaviyo = window.klaviyo || [];
				klaviyo.push(['track', 'Added to Cart', atcItem]);
			});
		}
	};

	/* Registry */
	const handleAddToBabyList = (url, title, image) => {
		bl.addToRegistry({
			images: image,
			price: currentVariantPrice.price,
			title: title,
			url: url,
		});
	};

	useEffect(() => {
		let btnEl = document.querySelectorAll(
			`.registry-trigger[data-variant-id="${currentVariantId}"]`
		);
		if (btnEl.length) {
			btnEl.forEach((i) => (i.innerHTML = registryHtml));
		}
	}, [currentVariantId]);

	const openModal = () => {
		setIsOpen(true);
	};

	const closeModal = (e) => {
		setKey(key + 1);
		setIsOpen(false);
		setQuickBuyActive(false);
	};

	useEffect(() => {
		if (quickBuyActive) {
			openModal();
		}
	}, [quickBuyActive]);

	return (
		<Modal
			isOpen={modalIsOpen}
			onRequestClose={closeModal}
			contentLabel='Quick Buy'
			className='quick-buy-modal'
			shouldCloseOnOverlayClick={true}
			overlayClassName='quick-buy-overlay w-full z-[30]'
		>
			<div
				id='quick-buy'
				key={key}
				className='quick-buy-outer px-6 pt-6 pb-6 lg:p-6 relative bg-white flex mx-auto gap-4 max-h-[80vh] overflow-y-auto'
			>
				<div className='modal-close flex items-center absolute -top-1 lg:top-2 right-1 lg:right-3'>
					<span
						className='close-modal cursor-pointer text-2xl lg:text-[36px] font-normal text-[#B8B9BA] hover:text-ash'
						onClick={closeModal}
					>
						&times;
					</span>
				</div>
				{firstVariant && firstVariant ? (
					<div className={`product-modal-outer w-full`}>
						<div className='product-modal-inner relative flex flex-wrap sm:flex-nowrap gap-x-6 lg:gap-6'>
							<div
								className='product-image relative flex flex-col items-center w-full sm:max-w-[380px]'
								data-color={firstVariant.initial_color}
							>
								<div className='image-container flex items-center justify-center w-full aspect-[2/3] overflow-hidden relative bg-[#f8f8f8]'>
									<a
										className='image-click w-full h-full flex items-center justify-center no-underline'
										href={currentProductUrl}
									>
										<img
											className={`mobile-image-swipe-image ${
												// Get aspect ratio directly from img element and check if it's close to 1
												((e) => {
													const img = new Image();
													img.src =
														currentImage?.src ||
														image?.src ||
														'';
													return (
														Math.abs(
															img.width /
																img.height -
																1
														) < 0.1
													);
												})()
													? 'w-[85%] h-[85%] object-contain'
													: 'w-full h-full object-cover'
											}`}
											src={
												currentImage
													? currentImage.src
													: image
													? image.src
													: null
											}
											alt={
												imageAlt
													? imageAlt
													: product.handle +
													  ' ' +
													  firstVariant.title
											}
											onError={(e) => {
												if (
													e.target.src !==
													DEFAULT_IMAGE_SRC
												) {
													e.target.onerror = null;
													e.target.src =
														DEFAULT_IMAGE_SRC;
												}
											}}
										/>
									</a>
								</div>
								{/* {ribbon ? (
                                    <div className="ribbon trunk-sale-ribbon absolute top-0 left-0 w-2/3">
                                        <Ribbon
                                            ribbonFill="#FFE293"
                                            textFill="#2EA9BE"
                                            text="WAREHOUSE SALE"
                                        />
                                    </div>
                                ) : null} */}

								<p className='text-xs my-2 text-flint hover:text-ash'>
									{currentProductUrl && (
										<a
											className='underline'
											href={currentProductUrl}
										>
											{embroidery
												? 'View full product details including embroidery'
												: 'View full product details'}
										</a>
									)}
								</p>
							</div>

							<div className={`product-inner relative w-full`}>
								<div className='product-top'>
									<h3 className='product-title text-lg lg:text-2xl mb-1 lg:mb-2'>
										<a
											className='no-underline hover:underline'
											href={currentProductUrl}
										>
											{currentProduct
												? currentProduct?.title.split(
														'_'
												  )[0]
												: product?.title.split('_')[0]}
										</a>
									</h3>

									<Price
										product={currentProduct || product}
										priceType='quickBuy'
									/>

									{/* <p className="product-available">
                                        Available in {patterns.length}{' '}
                                        {patterns.length === 1
                                            ? 'color'
                                            : 'colors'}
                                    </p> */}
								</div>
								<div className={`product-bottom pt-2 lg:pt-4`}>
									<div
										className={`product-actions ${
											sizes && sizes.length < 2
												? 'no-sizes'
												: null
										}`}
									>
										{patterns?.filter(
											(e) => e !== undefined
										).length > 0 ? (
											<div className='product-swatches py-2 lg:py-6 border-t border-slate'>
												<div className='color-text text-xs flex items-center mb-2'>
													<h2 className='text-sm'>
														Choose A Color
													</h2>{' '}
													<span className='current-color-text block ml-auto'>
														<span className='font-semibold'>
															Selected:
														</span>{' '}
														{currentPattern &&
															currentPattern}
													</span>
												</div>
												<ul className='swatch-list nostyle list-none grid grid-cols-[repeat(auto-fill,minmax(28px,28px))] lg:grid-cols-[repeat(auto-fill,minmax(40px,40px))] gap-1 !my-3 overflow-x-hidden'>
													{patterns
														? patterns.map((p) => {
																{
																	/*  */
																}
																// const swatchSlug = slugify(p.)
																return (
																	<li
																		key={
																			product?.id +
																			' ' +
																			p
																		}
																		className={`rounded-full border border-oat hover:border-ocean hover:border-2 swatch ${
																			p ===
																			currentPattern
																				? 'selected-swatch border-2 border-ocean'
																				: ''
																		}`}
																	>
																		<div
																			className='swatch-image'
																			data-product-id={
																				v.id
																			}
																			data-pattern={
																				p
																					? slugify(
																							p
																					  )
																					: null
																			}
																			aria-label={
																				p
																			}
																			data-balloon-pos='up'
																			onClick={() =>
																				handleSwatchClick(
																					p
																				)
																			}
																		>
																			<img
																				className='rounded-full'
																				src={`${FILES_URL}maswatch-${
																					p
																						? slugify(
																								p
																						  )
																						: 'default'
																				}-96.png`}
																				alt={`${
																					p
																						? p
																						: 'default'
																				} swatch`}
																				onError={(
																					e
																				) => {
																					if (
																						e
																							.target
																							.src !==
																						DEFAULT_SWATCH_IMAGE_SRC
																					) {
																						e.target.onerror =
																							null;
																						e.target.src =
																							DEFAULT_SWATCH_IMAGE_SRC;
																					}
																				}}
																			/>
																		</div>
																	</li>
																);
														  })
														: null}
												</ul>
											</div>
										) : null}
										{sizes && sizes.length ? (
											<div
												className={`product-sizes ${
													sizes && sizes.length < 2
														? 'hidden'
														: null
												}`}
											>
												<div className='product-sizes py-2 lg:py-6 border-t border-b border-y-slate'>
													<div className='size-text text-xs flex items-center mb-2'>
														<h2 className='text-sm'>
															Choose A Size
														</h2>{' '}
														<span className='current-size-text block ml-auto'>
															<span className='font-semibold'>
																Selected:
															</span>{' '}
															{currentSize.size &&
															currentSize.size !==
																'nosize'
																? currentSize.size
																: '(none)'}
														</span>
													</div>
													<ul className='size-list nostyle grid grid-cols-4 lg:grid-cols-6 gap-1 lg:gap-2'>
														{sizes.map((s, i) => {
															//
															if (
																s.initial_size &&
																s.initial_size !==
																	''
															) {
																return (
																	<li
																		key={
																			s.initial_size
																		}
																		className={`size h-[24px] lg:h-[36px] border border-oat rounded-sm flex items-center justify-center px-2 text-sm hover:cursor-pointer hover:bg-flint hover:text-white  ${
																			currentSize.size &&
																			currentSize.size ===
																				s.initial_size
																				? 'size-selected bg-ash text-white'
																				: 'bg-white'
																		} ${
																			s.inventory_quantity ===
																			0
																				? 'size-out-of-stock cursor-not-allowed pointer-events-none'
																				: ''
																		}`}
																		onClick={() =>
																			handleSizeClick(
																				s.initial_size,
																				s.variantId,
																				i,
																				s.sku
																			)
																		}
																		data-variant-id={
																			s.variantId
																		}
																	>
																		<span className='size-label text-xs'>
																			{
																				s.initial_size
																			}
																		</span>
																	</li>
																);
															}
															return null;
														})}
													</ul>
													<div className='size-guide-wrap ml-auto mt-2'>
														<SizeGuide />
													</div>
												</div>
											</div>
										) : null}

										<div className='add-to-wrap flex items-center flex-wrap w-full'>
											<div className='product-add-to-cart w-full'>
												{sizes && sizes.length > 2 ? (
													<button
														id='quick-buy-add-to-cart'
														type={
															!currentSize.size
																? null
																: 'submit'
														}
														className={`large-button button-atc w-full h-42px lg:!h-[60px] ${
															!currentSize.size
																? 'disabled noclick'
																: ''
														} ${
															isPLPTest &&
															plpTestId === '1'
																? 'quickbuy-atc-test-1'
																: isPLPTest &&
																  plpTestId ===
																		'2'
																? 'quickbuy-atc-test-2'
																: ''
														}`}
														// data-balloon-blunt
														data-balloon-pos='up'
														aria-label={
															!currentSize.size
																? 'Please select a size'
																: null
														}
														onClick={(e) =>
															handleAddToCart(e)
														}
													>
														Add To Cart
													</button>
												) : (
													<button
														type='button'
														className={`large-button button-atc button-no-sizes w-full bg-stone-500 `}
														data-variant-id={
															currentVariantId
														}
														onClick={(e) =>
															handleAddToCart(e)
														}
													>
														Add To Cart
													</button>
												)}
											</div>

											<div className='registry-actions flex items-center justify-center  mt-2 w-full'>
												{sizes && sizes.length > 2 ? (
													<button
														className={`registry-trigger large-button button-registry text-sm !h-[42px] gap-2 w-full ${
															!currentSize.size
																? 'disabled noclick opacity-80'
																: 'hover:bg-oat'
														}`}
														// disabled={!currentSize.size}
														data-variant-id={
															currentVariantId
														}
														data-balloon-blunt
														data-balloon-pos='up'
														aria-label={
															!currentSize.size
																? 'Please select a size'
																: null
														}
														onClick={() => {
															if (
																!currentSize.size
															) {
																nullFunction();
															} else {
																handleAddToBabyList(
																	`${
																		location.origin
																	}/products/${
																		product?.handle
																	}${
																		currentVariantId
																			? '?variant=' +
																			  currentVariantId
																			: null
																	}`,
																	product.title,
																	currentImage
																		? currentImage.src
																		: null,
																	currentVariantId,
																	1
																);
															}
														}}
													>
														<span className='flex items-center justify-center gap-2 w-full'>
															<Heart width='w-[24px]' />
															Add To Babylist
															Registry
														</span>
													</button>
												) : (
													<button
														className='registry-trigger large-button button-registry text-sm !h-[42px] gap-2 w-full hover:bg-oat'
														data-variant-id={
															currentVariantId
														}
														onClick={() => {
															if (
																!currentSize.size
															) {
																nullFunction();
															} else {
																handleAddToBabyList(
																	`${
																		location.origin
																	}/products/${
																		product?.handle
																	}${
																		currentVariantId
																			? '?variant=' +
																			  currentVariantId
																			: null
																	}`,
																	product.title,
																	currentImage
																		? currentImage.src
																		: null,
																	currentVariantId,
																	1
																);
															}
														}}
													>
														<span className='flex items-center justify-center gap-2 w-full '>
															<Heart width='w-[24px]' />
															Add To Babylist
															Registry
														</span>
													</button>
												)}
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				) : null}
			</div>
			<div className='close-text flex items-center justify-center text-center mx-auto mt-2'>
				<p
					className='font-normal text-sm underline mt-2'
					onClick={closeModal}
				>
					Close
				</p>
			</div>
		</Modal>
	);
};

export default QuickBuy;
